// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Link } from 'react-router-dom';
import { parseDuration } from '../../../../../../../lib/utility';
import HyperlinkLinkIcon from '../../../../../../../assets/images/hyperlink-link-icon.svg';
import { HyperlinkModule as HyperlinkModuleType } from '../../../../../../../types/Model';

import { S } from './styles';

interface HyperlinkModuleProps {
  active: boolean;
  module: HyperlinkModuleType;
  to: string;
}

const HyperlinkModule: React.FC<HyperlinkModuleProps> = (props):JSX.Element => {
  const {
    active,
    module: {
      name,
      type,
      status,
    },
    to
  } = props;

  return (
    <S.Container>
      <S.Link as={Link} to={to} active={active}>
        <S.TitleContainer>
          <S.Icon type={type}/>
          <S.Title>{name}<S.LinkIcon src={HyperlinkLinkIcon} style={{ marginLeft: '10px'}}/></S.Title>
        </S.TitleContainer>
        <S.FooterContainer>
          {status && <S.CompletionStatusTag type={status}/>}
        </S.FooterContainer>
      </S.Link>
    </S.Container>
  );
}

export { HyperlinkModule as default };
